import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '@interfaces/config.interface';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
    private http = inject(HttpClient);
    config = signal<Config | null>(null);

    async load(): Promise<void> {
        try {
            const cfg = await new Promise<Config>((resolve, reject) => {
                this.http.get<Config>('assets/config.json').subscribe({
                    next: resolve,
                    error: reject
                });
            });
            
            this.config.set(cfg);
        }
        catch {
            console.log("Config error...");

            this.config.set({
                api: { baseUrl: '', jobsUrl: '', jobDetailsUrl: '' },
                notification: { enabled: false, message: '', type: 'info' }
            })
        }
    }
}
